import React from "react"
import PropTypes from "prop-types"
import styles from "./index.module.css"

/**
 * Separator/Divider Component
 * A dashed separator line used to visually divide sections
 * @param {string} direction - 'horizontal' or 'vertical' (default: 'horizontal')
 * @param {string} className - Additional CSS classes
 * @param {object} style - Inline styles
 */
const Separator = ({ className = "", style = {} }) => {
  return (
    <div className={`${styles.separator} ${className}`} style={style} role="separator" />
  )
}

Separator.propTypes = {
  direction: PropTypes.oneOf(["horizontal", "vertical"]),
  className: PropTypes.string,
  style: PropTypes.object
}

Separator.defaultProps = {
  direction: "horizontal",
  className: "",
  style: {}
}

export default Separator
